export default __webpack_public_path__ + "static/media/EvertRuales.23f848af.png";